import { getComponentClasses } from '@99designs/common/utils/app/index';
import React from 'react';

interface Props {
    label: string;
    description?: string;
    required?: boolean;
    children: React.ReactNode;
    errorMessage?: string;
    variations?: string[];
}

const defaultProps: Partial<Props> = {
    description: '',
    required: false,
};

const BriefStepField: React.FunctionComponent<Props> = props => (
    <div
        className={getComponentClasses('field', props.variations)}
        data-field-error={props.errorMessage}
    >
        <label>
            <div className="paragraph paragraph--bold paragraph--no-margin">
                {props.label}
                {props.required && '*'}
            </div>
            {props.description && <div className="paragraph">{props.description}</div>}
        </label>
        {props.errorMessage && (
            <div className="field__validation">
                <p className="field__validation__message">{props.errorMessage}</p>
            </div>
        )}
        <div className="field__input">{props.children}</div>
    </div>
);

BriefStepField.defaultProps = defaultProps;

export default BriefStepField;
